import { motion } from "framer-motion";
import { proofBarItems } from "@/components/equinox/data";

export default function ProofBar() {
  return (
    <section className="px-6 pb-4 sm:px-8 lg:px-12" data-testid="proof-bar-section">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="mx-auto grid max-w-7xl gap-4 rounded-[2rem] border border-white/[0.08] bg-white/[0.04] p-4 backdrop-blur-2xl md:grid-cols-2 xl:grid-cols-4"
      >
        {proofBarItems.map((item, index) => (
          <div key={item} className="glitter-card glass-panel rounded-[1.35rem] px-4 py-4 text-sm text-white/[0.78]" data-testid={`proof-bar-item-${index + 1}`}>
            {item}
          </div>
        ))}
      </motion.div>
    </section>
  );
}